import { ActionAny, ActionRequest, createActions } from 'src/utils/createActions';
import { SearchPageData } from 'src/state/SearchState';
import { SearchParams } from 'src/state/SearchParams';

export type SearchRequest =
    ActionRequest<void, SearchParams>;
export type SearchActions =
    ActionAny<void, SearchPageData | null, SearchParams>;
export const SEARCH_ACTIONS =
    createActions<void, SearchPageData | null, SearchParams>('SEARCH');
